"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsAltBoxInfo = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
const _excluded = ["children", "dms_variant", "sx"],
  _excluded2 = ["Icon", "dms_variant", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const DmsAltBoxInfoCard = _ref => {
  let {
      children,
      dms_variant,
      sx
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.Card, _extends({
    sx: _objectSpread({
      display: 'flex',
      padding: '0.5rem',
      minHeight: '5rem',
      width: '100%'
    }, sx)
  }, props), children);
};
const DmsAltBoxInfoIcon = _ref2 => {
  let {
      Icon,
      dms_variant,
      sx
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_material.Box, _extends({
    sx: _objectSpread({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      width: '4.375rem',
      borderRadius: '0.25rem'
    }, sx)
  }, props), /*#__PURE__*/_react.default.createElement(Icon, {
    sx: {
      fontSize: '2.5rem'
    }
  }));
};
const DmsAltBoxInfoContent = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 0.625rem',
      overflow: 'hidden',
      justifyContent: 'center',
      flex: '1'
    }
  }, children);
};
const DmsAltBoxInfoContentTitle = _ref4 => {
  let {
    title
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, title);
};
const DmsAltBoxInfoContentValue = _ref5 => {
  let {
    value
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, {
    mt: 2,
    sx: {
      fontWeight: 700,
      whiteSpace: 'nowrap'
    }
  }, value);
};
const DmsAltBoxInfoContentProgress = _ref6 => {
  let {
    progress_value
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(_material.LinearProgress, {
    sx: {
      backgroundColor: 'rgba(0, 0, 0, 0.125)',
      '& .MuiLinearProgress-bar': {
        backgroundColor: 'white'
      },
      margin: '5px 0',
      height: '2px'
    },
    variant: "determinate",
    value: progress_value
  });
};
const DmsAltBoxInfoContentProgressDescription = _ref7 => {
  let {
    progress_description
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, null, progress_description);
};

/**
 * DmsAltBoxInfo Component
 * 
 * This component is a set of subcomponents designed to create
 * an info card with icons, titles, values, and a progress bar.
 * 
 * Components:
 * 
 * 1. DmsAltBoxInfoCard: A main container for the info card.
 *    - Props:
 *      - children: The child content to be rendered inside the card.
 *      - dms_variant: A string that defines the variant of the card (one of 'info', 'success', 'warning', or 'danger' from index.css).
 *      - sx: Additional styling applied to the component.
 *      - props: Any other properties supported by the Material-UI Card component.
 * 
 * 2. DmsAltBoxInfoIcon: A container for the icon inside the card.
 *    - Props:
 *      - Icon: The icon to be displayed.
 *      - dms_variant: A string that defines the variant of the icon (one of 'info', 'success', 'warning', or 'danger' from index.css).
 *      - sx: Additional styling applied to the component.
 *      - props: Any other properties supported by the Material-UI Box component.
 * 
 * 3. DmsAltBoxInfoContent: A container for the content inside the card.
 *    - Props:
 *      - children: The child content to be rendered inside the container.
 * 
 * 4. DmsAltBoxInfoContentTitle: A component to display the title inside the card.
 *    - Props:
 *      - title: The title to be displayed.
 * 
 * 5. DmsAltBoxInfoContentValue: A component to display the value inside the card.
 *    - Props:
 *      - value: The value to be displayed.
 * 
 * 6. DmsAltBoxInfoContentProgress: A component to display a progress bar.
 *    - Props:
 *      - progress_value: The progress value (0-100).
 * 
 * 7. DmsAltBoxInfoContentProgressDescription: A component to display a description of the progress.
 *    - Props:
 *      - progress_description: The description of the progress to be displayed.
 * 
 * Example Usage:
 * 
 * <DmsAltBoxInfo.Card>
 *   <DmsAltBoxInfo.Icon className='info' Icon={MailOutlineIcon} />
 *   <DmsAltBoxInfo.Content>
 *     <DmsAltBoxInfo.Title title="Info" />
 *     <DmsAltBoxInfo.Value value={1337} />
 *   </DmsAltBoxInfo.Content>
 * </DmsAltBoxInfo.Card>
 * 
 * Author: André Tragancin
 */
const DmsAltBoxInfo = exports.DmsAltBoxInfo = {
  Card: DmsAltBoxInfoCard,
  Icon: DmsAltBoxInfoIcon,
  Content: DmsAltBoxInfoContent,
  Title: DmsAltBoxInfoContentTitle,
  Value: DmsAltBoxInfoContentValue,
  Progress: DmsAltBoxInfoContentProgress,
  ProgressDescription: DmsAltBoxInfoContentProgressDescription
};